import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { SortDirection, SortEvent } from '../models/sort-event.model';

const rotate: { [key: string]: SortDirection } = {
  asc: 'desc',
  desc: 'asc',
};

@Directive({
  selector: '[siatSortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()',
  },
})
export class SortableHeaderDirective {
  @Input()
  siatSortable: string;

  @Input()
  direction: SortDirection = 'asc';

  @Output()
  sort = new EventEmitter<SortEvent>();

  /**
   *  Rotate the sorting direction.
   */
  rotate(): void {
    this.direction = rotate[this.direction];
    this.sort.emit({ sortable: this.siatSortable, direction: this.direction });
  }
}
